module.exports = __webpack_public_path__ + "assets/images/thumbnail-47299d3d814c5fb83ad0d43b9f715c6c.jpg";